import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxFormComponent } from 'devextreme-angular';
import { Constants } from 'src/app/app.constants';
import { AlertService } from 'src/app/core/alert.service';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { BaseService } from 'src/app/shared/base/base.service';
import { User } from '../../users/users.models';
import { ProfileService } from '../profile.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @ViewChild('passwordChangeForm', { static: false }) passwordChangeForm: DxFormComponent;
  @ViewChild('emailChangeForm', { static: false }) emailChangeForm: DxFormComponent;

  constructor(
    private profileService: ProfileService,
    private baseService: BaseService,
    public authService: AuthService,
    private alertService: AlertService,
    public loadingService: LoadingService,
    private router: Router
  ) { }

  user: User;

  displayEmailForm: boolean = false;
  emailFormData: { email: string } = { email: null };

  displayPasswordForm: boolean = false;
  passwordFormData: { oldPassword: string, newPassword: string, repeatPassword: string } = { oldPassword: null, newPassword: null, repeatPassword: null };


  ngOnInit(): void {
    this.baseService.getById(`${Constants.contextPath}/users`, this.authService.userId, (response: User) => {
      this.handleUserResponse(response);
    })
  }

  handleUserResponse(response: User) {
    this.user = response;
    this.emailFormData.email = response.email;
  }

  
  showEmailForm() {
    this.displayEmailForm = true;
  }

  showPasswordForm() {
    this.displayPasswordForm = true;
  }

  submitEmail() {
    if (this.emailChangeForm.instance.validate() != null && !this.emailChangeForm.instance.validate().isValid) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    }

    this.profileService.changeEmail(this.emailFormData.email, this.authService.userId, (response: any) => {
      this.displayEmailForm = false;
      this.alertService.success("PROFILE.EMAIL_CHANGE_COMPLETE");
    }, (error: any) => {
      this.alertService.error(error, true);
    })
  }

  submitPassword() {
    if (this.passwordChangeForm.instance.validate() != null && !this.passwordChangeForm.instance.validate().isValid) {
      this.alertService.error('SHARED.INVALID_FORM');
      return;
    }

    this.profileService.changePassword(this.passwordFormData, (response: any) => {
      this.displayPasswordForm = false;
      this.alertService.success('USERS.PASSWORD_CHANGE_COMPLETE');
      this.router.navigate(['logout']);
    }, (error: any) => {
      this.alertService.error(error, true);
    });
  }

  passwordComparison = () => {
    return this.passwordFormData.newPassword;
  };

  checkComparison() {
    return true;
  }

}
